import React from 'react'
import styles from './EventMagazineRow.module.scss'
import Container from '@/component/Primitive/Container'
import ResponsiveImage from '@/component/Primitive/ResponsiveImage'
import Hide from '@/component/Primitive/Hide'
import cx from 'classnames'
import { array, string, oneOf, object } from 'prop-types'

export const EventMagazineRow = ({ items, theme }) => (
  <div className={cx(styles.EventMagazineRow, theme === 'dark' && styles.dark)}>
    <Container center gutter className={styles.EventMagazineRowContainer}>
      {items?.map(({ image }, i) => {
        const { mobile: mobileImage, desktop: desktopImage } = image
        return (
          <div key={i} className={styles.ImageWrapper}>
            <Image device="desktop" image={desktopImage} />
            <Image device="mobile" image={mobileImage} />
          </div>
        )
      })}
    </Container>
  </div>
)

EventMagazineRow.propTypes = {
  items: array,
  theme: string
}

const Image = ({ device, image }) => {
  const hideProps =
    device === 'mobile' ? { at: 'desktop' } : { below: 'desktop' }
  const className =
    device === 'mobile' ? styles.mobileImage : styles.desktopImage
  return (
    <Hide {...hideProps} className={styles.ImageWrapper}>
      <ResponsiveImage className={cx(styles.Image, className)} {...image} />
    </Hide>
  )
}

Image.propTypes = {
  device: oneOf(['mobile', 'desktop']),
  image: object
}
